import { Modal } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Button } from '@/components_deprecated'
import React, { useState } from 'react'
import { isMobileOnly } from 'react-device-detect'

interface UploadModalButtonProps {
  /** Renders the modal body. `onClose` closes and resets the modal. */
  renderModal: (props: { onClose: () => void }) => React.ReactNode
}

export const UploadModalButton: React.FC<UploadModalButtonProps> = ({
  renderModal,
}) => {
  const [open, setOpen] = useState(false)
  // Bumping the key remounts the modal so its upload state resets on reopen.
  const [modalKey, setModalKey] = useState(0)

  const translations = useTranslate({
    uploadFile: 'common.upload-file',
  })

  const closeDialog = () => {
    setOpen(false)
    setModalKey(prev => prev + 1)
  }

  return (
    <>
      <Button
        className="attachment"
        height="38px"
        padding="0 1.5rem"
        borderRadius="8px"
        fontSize="0.8rem"
        color="white"
        iconLeftProps={{ icon: 'add', type: 'regular' }}
        onClick={() => setOpen(true)}
      >
        {translations.uploadFile}
      </Button>

      <Modal
        open={open}
        offset={isMobileOnly ? 8 : 36}
        placement="top-center"
        direction="from-top"
        onClose={closeDialog}
      >
        <React.Fragment key={modalKey}>
          {renderModal({ onClose: closeDialog })}
        </React.Fragment>
      </Modal>
    </>
  )
}
